// extracted by mini-css-extract-plugin
export default {"filterSection":"filter_filterSection__1YQm-","filterGroup":"filter_filterGroup__lSAUb"};